import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function ContratsDeVente({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Monsieur,</p>
      <p>
        Dans le but d'améliorer le fonctionnement de mon service, je pense qu'il
        serait judicieux de disposer de plus d'autonomie que j'ai pu en avoir
        avec {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom}. J'aimerais
        notamment que mon service ait toute la latitude nécessaire pour traiter
        l'ensemble des contrats de vente et ce, quel que soit le montant.
      </p>
      <p>
        Je vous rappelle que, pour les contrats excédant 160 000 €,{" "}
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom}, votre prédécesseur,
        devait donner son accord. Ce système avait pour résultat d'alourdir la
        procédure et de restreindre la zone d'autonomie d'action de mon service.
      </p>
      <p>Respectueusement</p>
      <MailSignature
        emetteurLogo={ContratsDeVente.metadata.emetteurLogo}
        emetteur={ContratsDeVente.metadata.emetteur}
        emetteurPoste={ContratsDeVente.metadata.emetteurPoste}
        emetteurEntreprise={ContratsDeVente.metadata.emetteurEntreprise}
      />
    </div>
  );
}

ContratsDeVente.metadata = {
  titre: "Contrats de Vente",
  cleMail: "contrats_de_vente",
  messageTransfert: false,
  emetteur: "Leïla SEBAG",
  emetteurPoste: "Responsable du service Commercial",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default ContratsDeVente;
